module.exports = __webpack_public_path__ + "img/MP3_music_icon@2x.c3088a3c.png";